/**
 * <AgeLimit />
 *
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Select from 'react-select';
import parseJson from '../../parseJson';
import Age from '../Age';
import './AgeLimit.scss';

const DEFAULT_VALUE = {
  min: 23,
  max: 23,
}

export function agelimit(props) {
  const {
    schema,
    onChange,
    options,
    placeholder,
  } = props;

  const {
    name,
  } = schema;

  const {
    maxlength,
  } = options;

  let value = parseJson(props.value || DEFAULT_VALUE);

  return (
    <AgeLimit
      name={name}
      value={value}
      onChange={(data)=>{ props.onChange(JSON.stringify(data)); }}
      {...options}
    />
  );
}

class AgeLimit extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeAge = this.onChangeAge.bind(this);
  }

  onChangeAge(name) {
    return (newAge)=>{
      const {
        value,
        onChange,
      } = this.props;

      let {
        min,
        max,
      } = value

      if (name === 'max') {
        if (min > newAge) {
          min = newAge;
        }
        max = newAge;
      }

      if (name === 'min') {
        if (newAge > max) {
          max = newAge;
        }
        min = newAge;
      }

      onChange({
        min,
        max,
      });
    }
  }

  render() {
    const {
      name,
      value,
      onChange,
    } = this.props

    return (
      <div className='age-limit-wrapper form-input'>
        <div className='age-container'>
          <div className='age-limit-label'>{__('Minimum')}</div>
          <Age value={value.min} onChange={this.onChangeAge('min')} />
        </div>
        <div className='age-container'>
          <div className='age-limit-label'>{__('Maximum')}</div>
          <Age value={value.max} onChange={this.onChangeAge('max')} />
        </div>
      </div>
    )
  }
}

export default AgeLimit;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/AgeLimit/index.js